// ----------------------------------------------------------------------------
// Nombre del Programa : DetalleRol
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el detalle de los roles de usuario 
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './DetalleRol.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useNavigate, useParams } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import { RolProps, PantallasProps } from '../../../interfaces/rolesInterfaces';
import { getRol, postRol } from '../../../Services/RolesService';
import { getPantallas } from '../../../Services/PantallasService';

export const DetalleRol = () => {
  const [rolId, setRolId] = useState('0');
  const [pantallas, setPantallas] = useState<PantallasProps[]>([]);
  const [rol, setRol] = useState<RolProps>();
  const [nombreRol, setNombreRol] = useState('');
  const [cargado, setCargado] = useState<boolean>(false);
  const [recargar, setRecargar] = useState<boolean>(false);

  const navigate = useNavigate();

  const params = useParams();
  let idrol = params.id;

  useEffect(() => {
    if (idrol !== '0') {
      setRolId(idrol!);
      cargarRol(idrol!);
    } else {
      let nrol = {} as RolProps;
      nrol.estatus = 1;
      nrol.tiporol_id = 0;
      setRol(nrol);
      cargarPantallas();
    }
  }, []);

  const cargarRol = async (id: String) => {
    setCargado(false);
    const response: any = await getRol(id).catch(({ response }) => {
      const { data } = response;
      const nopantallas: PantallasProps[] = [];
      let nrol = {} as RolProps;
      setPantallas(nopantallas);
      setRol(nrol);
      StatusAlertService.showError(data.meta.message);
      setCargado(true);
    });
    if (response.data && response.data.data) {
      setRol(response.data.data[0]);
      setPantallas(response.data.data[0].pantallas);
      setNombreRol(response.data.data[0].nombreRol);
      setCargado(true);
    }
  };

  const cargarPantallas = async () => {
    setCargado(false);
    const response: any = await getPantallas().catch(({ response }) => {
      const { data } = response;
      const nopantallas: PantallasProps[] = [];
      setPantallas(nopantallas);
      StatusAlertService.showError(data.meta.message);
      setCargado(true);
    });
    if (response.data && response.data.data) {
      setPantallas(response.data.data);
      setCargado(true);
    }
  };

  const guardarRol = async () => {
    if (nombreRol === '') {
      StatusAlertService.showError('Ingrese el nombre para el rol');
      return;
    }
    /*else if (pantallas.filter(pantalla => pantalla.selected === true).length <= 0) {
            StatusAlertService.showError('Seleccione al menos una pantalla para el rol');
            return;
        }*/

    pantallas.forEach((pantalla) => {
      pantalla.pantallarol_id =
        pantalla.pantallarol_id === null ? 0 : pantalla.pantallarol_id;
    });

    rol!.nombreRol = nombreRol;
    rol!.pantallas = pantallas;

    //console.log('rol:', rol);

    const response: any = await postRol(rol!).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      navigate(-1);
    }
    else if (response.response.data && response.response.data.meta) {
      StatusAlertService.showError(response.response.data.meta.message);
    }
  };

  const enterNombreRol = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
    }
  };
  const handleChangeNombreRol = (event: any) => {
    setNombreRol(event.target.value);
  };
  const onChangeCheckPantalla = (index: number) => {
    setRecargar(!recargar);
    pantallas[index].selected = !pantallas[index].selected;
  };

  return (
    <>
      <div className="m-5">
        <Row className="mb-2">
          <Col className="heading-1">
            Roles y permisos {'>'} {rolId === '0' ? 'Nuevo rol' : 'Editar rol'}
          </Col>
        </Row>
        <Row className="mt-3 agregar-rol">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">
                {rolId === '0' ? 'Nuevo rol' : 'Editar rol'}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>Nombre</Form.Label>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Ingrese el nombre"
                    aria-label="Search"
                    value={nombreRol}
                    maxLength={100}
                    onKeyPress={enterNombreRol}
                    onChange={handleChangeNombreRol}
                    className="cajabordeabajo"
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12}>
                {pantallas.length > 0 ? (
                  pantallas.map((pantalla, index) => (
                    <div key={pantalla.pantalla_id}>
                      <label>
                        <input
                          className="primary checkpantallas"
                          type="checkbox"
                          checked={pantalla.selected}
                          //onChange={(e) => usuarios[index].seleccionado = !usuarios[index].seleccionado}
                          onChange={(e) => onChangeCheckPantalla(index)}
                        />
                        {pantalla.nombre}
                      </label>
                    </div>
                  ))
                ) : cargado ? (
                  <tr className="colorgray2">
                    <td className="nodatos    " colSpan={4}>
                      No Existen Datos
                    </td>
                  </tr>
                ) : (
                  ''
                )}
              </Col>
            </Row>
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button
                variant="primary"
                className="float-end"
                onClick={() => guardarRol()}
              >
                Guardar
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Regresar
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
